export default "__VITE_ASSET__C43KLM8m__"